import { checkAndExecute } from 'root/api/helpers';

export default function UserSecurityAPI(api) {
  Object.assign(api, {
    manageAccount: {
      listUsersAndInvitations: () => api.server.get('current-user/account/list-user-accounts-and-invitations'),

      updateUserAssignmentsAndType: (accountId, userAccountId, userType, managedAccounts, notify) => checkAndExecute(
        () => userAccountId && userType && managedAccounts,
        () => api.server.put(`account/${accountId}/user-account/${userAccountId}/update-assignments-and-type`,
          { type: userType, managedAccounts, notify }),
      ),

      updateInviteeAssignmentsAndType: (accountId, invitationId, userType, managedAccounts, notify) => checkAndExecute(
        () => invitationId && userType && managedAccounts,
        () => api.server.put(`account/${accountId}/invitation/${invitationId}/update-assignments-and-type`,
          { type: userType, managedAccounts, notify }),
      ),

      updateUserType: (accountId, userAccountId, userType) => checkAndExecute(
        () => userAccountId && userType,
        () => api.server.put(`account/${accountId}/user-account/${userAccountId}/update-type`,
          { type: userType }),
      ),

      updateInviteeType: (accountId, invitationId, userType) => checkAndExecute(
        () => invitationId && userType,
        () => api.server.put(`account/${accountId}/invitation/${invitationId}/update-type`,
          { type: userType }),
      ),
    },
  });
}
